<template>
  <div class="google-pay-method">
    <!-- webstore  gid 为 28 的时候不展示 google pay -->
    <div class="method" :class="{ noClick: loadingShow }" @click="handleGooglePay" v-if="googlePriceOld || googlePrice">
      <div class="methods">
        <div class="method-img"><img src="@/assets/packageAssets/common/google.png" alt="" /></div>
        <div class="line"></div>
        <div class="method-name">
          <span>Google Pay</span>
          <div class="rate">
            <div :style="{ width: longestWidth + 'px' }" class="pay-price" v-if="googlePriceOld">
              <span>{{ googlePriceOld }}</span>
            </div>
            <div :style="{ width: longestWidth + 'px' }" class="pay-price" v-if="googlePrice">
              <i>{{ currency }}</i>
              <span>{{ googlePrice }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    longestWidth: {},
    loadingShow: {},
    googlePrice: {},
    currency: {},
    googlePriceOld: {}
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    // 调谷歌的时候需要客户端提供方法
    handleGooglePay() {
      // payGoogle.postMessage('')
      this.$emit('googlePay')
    }
  }
}
</script>

<style lang="less" scoped>
.google-pay-method {
  .method {
    width: 100%;
  }
  .methods {
    display: flex;
    align-items: center;
    width: 100%;
    height: 56px;
    padding: 0 8px;
    margin-bottom: 20px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 10px;

    .method-img {
      display: flex;
      justify-content: center;
      > img {
        height: 32px;
        object-fit: contain;
      }
    }
    .line {
      height: 20px;
      margin: 0 5px;
      border-right: 1px solid #d8d8d8;
    }
    .method-name {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      line-height: 17px;
      font-family: Inter-Regular;
      font-weight: 600;
      font-size: 14px;
      color: #333333;

      .rate {
        display: flex;
        align-items: center;
        .pay-price {
          position: relative;
          // height: 36px;
          padding: 8px 5px;
          // line-height: 36px;
          background: #424145;
          border-radius: 6px;
          font-family: Inter-Regular;
          font-weight: 600;
          font-size: 15px;
          color: #ffd786;
          text-align: center;
          i {
            font-size: 8px;
          }
        }
        .pay-loading {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .actTextColor {
          opacity: 0.1;
        }
      }
    }
  }
  .noClick {
    pointer-events: none;
  }
}
</style>
